import { Component, Mixins } from 'vue-property-decorator';
import { TjipFormGroupMixin, TjipFormItemTextMixin, TjipFormGroupValueMixin } from '@tjip/vuejs';
import AppFormControlFileUploadComponentVue from './AppFormControlFileUploadComponent.vue';
import { AppFormControlFileUploadComponent } from './AppFormControlFileUploadComponent';
import { AppFormItemFileUploadMixin } from './AppFormItemFileUploadMixin';
import { AppFiltersMixin } from '@/mixins/AppFiltersMixin';

@Component({
  components: {
    'app-form-control-file-upload': AppFormControlFileUploadComponentVue
  }
})
export class AppFormGroupFileUploadComponent extends Mixins(
  TjipFormGroupValueMixin,
  TjipFormItemTextMixin,
  TjipFormGroupMixin,
  AppFormItemFileUploadMixin,
  AppFiltersMixin
) {
  public get control(): AppFormControlFileUploadComponent {
    return this.$refs.control as AppFormControlFileUploadComponent;
  }
}

export default AppFormGroupFileUploadComponent;
